import type { TokenizedApi } from '@tokenized/sdk-js-private';
import { useContext } from 'react';
import { tokenizedApiContext } from '../internal/context';

/**
 * **`React hook`** providing access to the
 * {@link TokenizedApi} session manager.
 *
 * @returns The session manager created by
 *   or passed into {@link TokenizedApiProvider}.
 */
export function useTokenizedApi(): TokenizedApi {
  return useContext(tokenizedApiContext)!;
}
